import React, { useState, useEffect } from "react";
import { useSite } from "../../util/sites";
import { Link, useRouter } from "../../util/router";
import { useUser } from "../../util/user";

function NavbarUser() {
	const currentSite = useSite();
	const router = useRouter();
	const user = useUser();

	const [currentPath, setCurrentPath] = useState(router.pathname);
	const [siteID, setSiteID] = useState(null);
	const [siteIsSelected, setSiteIsSelected] = useState(false);

	const selectedSite = currentSite.selectedSite?.value;
	const isNoPVSite = selectedSite?.is_no_PV;

	useEffect(() => {
		if (
			currentSite.selectedSite != null &&
			currentSite.selectedSite.value !== "all"
		) {
			const site = currentSite.selectedSite;
			setSiteID(site.value.site_id);
			setSiteIsSelected(true);
		}
		return () => setSiteIsSelected(false);
	}, [currentSite.selectedSite]);

	useEffect(() => {
		if (currentPath != router.pathname) {
			setCurrentPath(router.pathname);
		}
	}, [router.pathname]);

	return (
		user.roles != null && (
			<ul className="nav navbar-nav">
				{user.roles.includes("overview:_view") && (
					<li
						className={
							currentPath === "/solar/overview"
								? "active nav-items"
								: "nav-items"
						}
					>
						<Link to={"/solar/overview"}>OVERVIEW</Link>
					</li>
				)}
				{siteIsSelected && !isNoPVSite && user.roles.includes("dashboard:_view") && (
					<li
						className={
							currentPath == `/solar/dashboard/${siteID}`
								? "active nav-items"
								: "nav-items"
						}
					>
						<Link to={"/solar/dashboard/" + siteID}>DASHBOARD</Link>
					</li>
				)}
				{siteIsSelected && !isNoPVSite && user.roles.includes("analytics:_view") && (
					<li
						className={
							currentPath === "/solar/analytics"
								? "active nav-items"
								: "nav-items"
						}
					>
						<Link to="/solar/analytics">ANALYTICS</Link>
					</li>
				)}
				{(siteIsSelected && currentSite?.selectedSite?.value?.is_BESS && user.roles.includes("dashboard:_view")) ? (
					<li
						className={
							currentPath === "/solar/bess" ? "active nav-items" : "nav-items"
						}
					>
						<Link to="/solar/bess">BESS</Link>
					</li>
				) : null}
				{siteIsSelected && !isNoPVSite && user.roles.includes("map:_view") && (
					<li
						className={
							currentPath === "/solar/map" ? "active nav-items" : "nav-items"
						}
					>
						<Link to="/solar/map">MAP</Link>
					</li>
				)}
				{siteIsSelected && !isNoPVSite && user.roles.includes("extract:_view") && (
					<li
						className={
							currentPath === "/solar/extract"
								? "active nav-items"
								: "nav-items"
						}
					>
						<Link to="/solar/extract">EXTRACT</Link>
					</li>
				)}
				{siteIsSelected && !isNoPVSite && user.roles.includes("alarms:_view") && (
					<li
						className={
							currentPath === "/solar/alarms" ? "active nav-items" : "nav-items"
						}
					>
						<Link to="/solar/alarms">ALARMS</Link>
					</li>
				)}
				{(user.roles.includes("administration:_view") || user.roles.includes("_CLIENT:VN")) && (
					<li
						className={
							currentPath === "/solar/administration/overview" ||
								currentPath === "/solar/administration/download" ||
								currentPath === "/solar/administration/issues" ||
								currentPath === "/solar/administration/summary" ||
								currentPath === "/solar/administration/invoice"
								? "active nav-items"
								: "nav-items"
						}
					>
						<Link to="/solar/administration">ADMINISTRATION</Link>
					</li>
				)}
				{/* {user.roles.includes("playground:_view") && (
            <li
              className={
                currentPath === "/solar/playground"
                  ? "active nav-items"
                  : "nav-items"
              }
            >
              <Link to="/solar/playground">PLAYGROUND</Link>
            </li>
          )} */}
			</ul>
		)
	);
}

export default NavbarUser;
